(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["youy-banner-campanha"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('youy-campanha-slider')) {
    class YouyCampanhaSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.youy-campanha__track');
        this.dots = Array.from(this.querySelectorAll('.youy-campanha__dot'));
        this.slides = Array.from(this.querySelectorAll('.youy-campanha__slide'));
        if (!this.track || this.slides.length < 2) return;
        this.index = 0;
        this.delay = parseInt(this.dataset.autoplay || '0', 10);
        this.dots.forEach((dot) => dot.addEventListener('click', () => { this.go(parseInt(dot.dataset.index, 10)); this.restart(); }));
        this.track.addEventListener('scroll', () => {
          window.clearTimeout(this._s);
          this._s = window.setTimeout(() => this.sync(), 80);
        }, { passive: true });
        ['mouseenter', 'focusin', 'touchstart'].forEach((ev) => this.addEventListener(ev, () => this.stop(), { passive: true }));
        ['mouseleave', 'focusout', 'touchend'].forEach((ev) => this.addEventListener(ev, () => this.restart(), { passive: true }));
        document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.restart()));
        if (window.Shopify && Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            const i = this.slides.findIndex((s) => s.contains(e.target) || s === e.target);
            if (i > -1) { this.stop(); this.go(i); }
          });
        }
        this.restart();
      }
      disconnectedCallback() { this.stop(); }
      go(i) {
        const n = this.slides.length;
        this.index = ((i % n) + n) % n;
        this.track.scrollTo({ left: this.slides[this.index].offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        this.mark();
      }
      sync() {
        const w = this.track.clientWidth || 1;
        this.index = Math.round(this.track.scrollLeft / w);
        this.mark();
      }
      mark() {
        this.dots.forEach((d, k) => d.setAttribute('aria-selected', k === this.index ? 'true' : 'false'));
      }
      stop() { window.clearInterval(this._t); this._t = null; }
      restart() {
        this.stop();
        if (this.delay > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this._t = window.setInterval(() => this.go(this.index + 1), this.delay);
        }
      }
    }
    customElements.define('youy-campanha-slider', YouyCampanhaSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["youy-hero-slides"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('youy-hero-slides')) {
    customElements.define('youy-hero-slides', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.yhs__track');
        this.slides = [...this.querySelectorAll('.yhs__slide')];
        this.dots = [...this.querySelectorAll('.yhs__dot')];
        this.index = 0;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.slides.forEach((slide, i) => {
          const v = slide.querySelector('video');
          const btn = slide.querySelector('.yhs__sound');
          if (!v) return;
          v.addEventListener('ended', () => { if (this.slides.length > 1 && i === this.index) this.go(i + 1); });
          if (btn) btn.addEventListener('click', (e) => {
            e.preventDefault(); e.stopPropagation();
            const on = v.muted;
            v.muted = !on;
            btn.setAttribute('aria-pressed', on ? 'true' : 'false');
            btn.setAttribute('aria-label', on ? 'Desativar som' : 'Ativar som');
            if (on) this.playVideo(v);
          });
        });
        this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i)));
        this.track.addEventListener('scroll', () => {
          clearTimeout(this._t);
          this._t = setTimeout(() => {
            const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
            if (i !== this.index) this.activate(i);
          }, 120);
        }, { passive: true });
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((e) => { this.visible = e.isIntersecting; this.visible ? this.activate(this.index) : this.pauseAll(); });
        }, { threshold: 0.3 });
        this.io.observe(this);
      }
      playVideo(v) { const p = v.play(); if (p && p.catch) p.catch(() => {}); }
      pauseAll() { clearTimeout(this.timer); this.slides.forEach((s) => { const v = s.querySelector('video'); if (v) v.pause(); }); }
      activate(i) {
        this.index = i;
        this.dots.forEach((d, n) => d.setAttribute('aria-selected', n === i ? 'true' : 'false'));
        clearTimeout(this.timer);
        if (this.offsetParent === null || this.visible === false) return;
        this.slides.forEach((s, n) => {
          const v = s.querySelector('video');
          if (!v) return;
          if (n === i) { if (!this.reduced) { if (this.slides.length > 1) v.currentTime = 0; this.playVideo(v); } }
          else v.pause();
        });
        const active = this.slides[i];
        const hasVideo = active && active.querySelector('video');
        if (this.slides.length > 1 && !this.reduced && (!hasVideo || hasVideo.error)) {
          const sec = parseFloat(this.dataset.interval) || 6;
          this.timer = setTimeout(() => this.go(i + 1), sec * 1000);
        }
      }
      go(i) {
        i = (i + this.slides.length) % this.slides.length;
        this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
        this.activate(i);
      }
      disconnectedCallback() { this.pauseAll(); if (this.io) this.io.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["youy-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('youy-video')) {
    customElements.define('youy-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.btn = this.querySelector('.youy-vd__sound');
        this.mq = window.matchMedia('(max-width: 749px)');
        this.pick = () => {
          const mobile = this.mq.matches && this.dataset.mobile;
          const src = mobile ? this.dataset.mobile : (this.dataset.desktop || this.dataset.mobile);
          const poster = mobile ? this.dataset.posterMobile : this.dataset.posterDesktop;
          if (poster) this.video.poster = poster;
          if (src && this.video.getAttribute('src') !== src) {
            this.video.setAttribute('src', src);
            if (this.visible) this.play();
          }
        };
        this.mq.addEventListener('change', this.pick);
        this.pick();
        this.btn.addEventListener('click', () => {
          const on = this.video.muted;
          this.video.muted = !on;
          this.btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          this.btn.setAttribute('aria-label', on ? 'Desativar som' : 'Ativar som');
          if (on) this.play();
        });
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            this.visible = e.isIntersecting;
            if (e.isIntersecting) { this.play(); } else { this.video.pause(); }
          });
        }, { threshold: 0.25 });
        this.io.observe(this);
      }
      play() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches && this.video.muted) return;
        const p = this.video.play();
        if (p && p.catch) p.catch(() => {});
      }
      disconnectedCallback() { if (this.io) this.io.disconnect(); if (this.mq) this.mq.removeEventListener('change', this.pick); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
